module.exports = __webpack_public_path__ + "static/media/about-bg.da84d767.jpg";